@for (divider of dividerImages; track divider.imgName) {
    <img
        [ngSrc]="divider.imgName | asset: 'shared/divider-img' : 'webp'"
        [width]="divider.width"
        [height]="divider.height"
        alt="divider"
        [class]="divider.classNames"
    />
}
